(() => {
  const qs = (selector, context = document) => context.querySelector(selector);
  const qsa = (selector, context = document) => Array.from(context.querySelectorAll(selector));

  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR"
    }).format(value);
  };

  qsa("[data-nav-toggle]").forEach((button) => {
    const target = qs(button.getAttribute("data-nav-toggle"));
    if (!target) return;

    button.addEventListener("click", () => {
      const expanded = button.getAttribute("aria-expanded") === "true";
      button.setAttribute("aria-expanded", String(!expanded));
      target.hidden = expanded;
    });
  });

  qsa("[data-gallery-root]").forEach((gallery) => {
    const mainImage = qs("[data-gallery-main]", gallery);
    const thumbs = qsa("[data-gallery-thumb]", gallery);

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        if (!mainImage) return;
        const { imageUrl, imageAlt } = thumb.dataset;
        mainImage.src = imageUrl;
        if (imageAlt) mainImage.alt = imageAlt;
        thumbs.forEach((node) => node.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });
  });

  qsa(".product-form").forEach((form) => {
    const submitButton = qs("[data-add-to-cart]", form);
    const toast = qs("[data-cart-toast]");
    const toastMessage = qs("[data-cart-toast-message]");
    const variantSelect = qs("[data-variant-select]", form);
    const priceTarget = qs("[data-product-price]");
    const compareTarget = qs("[data-product-compare]");
    const statusTarget = qs("[data-product-status]");
    const quantityInput = qs("[data-quantity-input]", form);

    qsa("[data-quantity-change]", form).forEach((button) => {
      button.addEventListener("click", () => {
        if (!quantityInput) return;
        const step = Number(button.dataset.quantityChange || 0);
        const nextValue = Math.max(1, Number(quantityInput.value || 1) + step);
        quantityInput.value = String(nextValue);
      });
    });

    const syncVariant = () => {
      if (!variantSelect || !priceTarget) return;
      const option = variantSelect.selectedOptions[0];
      if (!option) return;

      priceTarget.textContent = formatMoney(option.dataset.price);

      if (compareTarget) {
        const compare = Number(option.dataset.compare || 0);
        compareTarget.textContent = compare > Number(option.dataset.price || 0) ? formatMoney(compare) : "";
      }

      if (statusTarget) {
        statusTarget.textContent = option.disabled ? "Rupture temporaire" : "Disponible";
      }

      if (submitButton) {
        submitButton.disabled = option.disabled;
        submitButton.textContent = option.disabled ? "Épuisé" : "Ajouter au panier";
      }
    };

    if (variantSelect) {
      variantSelect.addEventListener("change", syncVariant);
      syncVariant();
    }

    form.addEventListener("submit", async (event) => {
      const activeSubmitter = document.activeElement;
      if (activeSubmitter && activeSubmitter.name === "checkout") return;

      event.preventDefault();
      if (!submitButton) return;
      submitButton.disabled = true;
      const previousText = submitButton.textContent;
      submitButton.textContent = "Ajout en cours...";

      try {
        const formData = new FormData(form);
        const addResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            Accept: "application/json"
          },
          body: formData
        });

        if (!addResponse.ok) {
          throw new Error("Impossible d'ajouter ce produit au panier.");
        }

        const item = await addResponse.json();
        const cartResponse = await fetch("/cart.js", {
          headers: {
            Accept: "application/json"
          }
        });
        const cart = await cartResponse.json();

        qsa("[data-cart-count]").forEach((node) => {
          node.textContent = cart.item_count;
          node.hidden = cart.item_count < 1;
        });

        if (toast && toastMessage) {
          toastMessage.textContent = `${item.product_title} a bien été ajouté à votre panier.`;
          toast.hidden = false;
          window.clearTimeout(window.__cartToastTimer);
          window.__cartToastTimer = window.setTimeout(() => {
            toast.hidden = true;
          }, 3200);
        }
      } catch (error) {
        if (statusTarget) {
          statusTarget.textContent = error.message;
        }
      } finally {
        submitButton.disabled = false;
        submitButton.textContent = previousText;
        syncVariant();
      }
    });
  });

  qsa("[data-scent-filter]").forEach((filter) => {
    filter.addEventListener("change", () => {
      const rootSelector = filter.getAttribute("data-scent-filter");
      const root = qs(rootSelector);
      if (!root) return;

      const selected = filter.value.trim().toLowerCase();
      qsa("[data-product-card]", root).forEach((card) => {
        const scents = (card.getAttribute("data-scents") || "").toLowerCase();
        card.hidden = selected !== "" && !scents.includes(selected);
      });
    });
  });

  const revealObserver = "IntersectionObserver" in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.14 })
    : null;

  qsa("[data-reveal]").forEach((element) => {
    if (revealObserver) {
      revealObserver.observe(element);
    } else {
      element.classList.add("is-visible");
    }
  });
})();
